import React from 'react';

import OAuthLogin from '../../components/loginpages/OAuthLogin';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig, createOAuthHelpText } from '../types';
import { OAuthHandlers } from '../types';

const bouncieConfig: TSPConfig = {
  key: 'bouncie',
  name: 'Bouncie',
  category: TSPCategory.OAUTH,

  // OAuth configuration
  oauth: {
    authUrl: 'https://auth.bouncie.com/dialog/authorize',
    requiredParams: ['client_id', 'response_type', 'redirect_uri', 'state'],
    getRedirectUri: (linkState: string) =>
      `${process.env.REACT_APP_REDIRECT_URL}/bouncie`,
    // Note: Bouncie uses clean redirect URI, state is passed as separate parameter
    urlBuildingOptions: {
      customUrlBuilder: (params) => {
        const { authUrl, clientID, redirectUri, linkState } = params;
        const urlParams = new URLSearchParams();
        urlParams.append('client_id', clientID);
        urlParams.append('response_type', 'code');
        urlParams.append('redirect_uri', redirectUri); // Clean redirect URI
        urlParams.append('state', linkState); // State as separate parameter
        return `${authUrl}?${urlParams.toString()}`;
      },
    },
    callbackOptions: {
      // Bouncie uses the API key as the authorization code in the onboard payload
      useApiKeyAsAuthorizationCode: true,
      // API field mappings for the onboard endpoint
      apiFieldMappings: {
        redirectUriField: 'bouncie_redirect_uri',
        // Bouncie integration specifically looks for 'code' field
        additionalFields: {
          code: 'apiKey', // Map 'code' field to the apiKey value
        },
      },
    },
  },

  helpText: createOAuthHelpText('Bouncie'),
  loginComponent: (
    props: LoginComponentProps,
    oAuthHandlers?: OAuthHandlers
  ) => {
    return (
      <OAuthLogin
        onDirectConnect={() => {
          oAuthHandlers?.initiateOAuth('bouncie');
        }}
        tsp='bouncie'
        serviceName={props.serviceName || ''}
        onValidityChange={props.onValidityChange}
      />
    );
  },
};

export default bouncieConfig;
